
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../../styles/Footer.css'
export default function Footer() {
  return (
    <footer className="footer footer--dark">
      <div className="footer__container max-w-7xl mx-auto">
        <div className="footer__grid">
          <div>
            <h3 className="footer__title">Nice Moulins Solidarités 06</h3>
            <div className="space-y-2">
              <p className="footer__contact">
                <MapPin className="footer__contact-icon" />
                <span>251 Avenue de la Porte des Alpes</span>
                <span>Plan du Var</span>
                <span>06670 Levens</span>
              </p>
              <p className="footer__contact">
                <Phone className="footer__contact-icon" />
                <span>+33 6.45.42.42.33</span>
              </p>
              <p className="footer__contact">
                <Mail className="footer__contact-icon" />
                <span>secretariat@nms06.fr</span>
              </p>
            </div>
          </div>

          <div>
            <h3 className="footer__title">Liens Utiles</h3>
            <ul className="footer__links">
              <li>
                <Link to="/privacy" className="footer__link">
                  Politique de confidentialité (RGPD)
                </Link>
              </li>
              <li>
                <Link to="/terms" className="footer__link">
                  Conditions d utilisation
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer__link">
                  Nous contacter
                </Link>
              </li>
              <li>
                <a href="mailto:secretariat@nms06.fr" className="footer__link">
                  Contacter le DPO
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="footer__title">Horaires d ouverture</h3>
            <ul className="footer__hours">
              <li>Lundi - Vendredi - 17h</li>
              <li>Samedi - 12h</li>
              <li>Dimanche</li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Nice Moulins Solidarités 06. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
